export default __webpack_public_path__ + "static/media/scissors.f2186774.png";